import { getData, postData, putData, deleteData } from "../apiClient";

// get hall images with pagination
export const getHallImagesWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search,
        });

        const result = await getData(`/hall-images/?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result,
        };
    } catch (error) {
        console.error("Get Hall Images with pagination API error:", error);
        return {
            success: false,
            ...error,
        };
    }
};

// get hall image data with id
export const getHallImageWithId = async (id) => {
    try {
        const result = await getData(`/hall-images/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Hall Image data API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

// create hall image
export const createHallImage = async ({ data }) => {
    try {
        const result = await postData(
            `/hall-images/add-hall-image`,
            data,
            { "Content-Type": "multipart/form-data" }
        );

        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error(
            "Hall Image add API error:",
            error.status === 400 ? error.error : error.message
        );

        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data?.errors : error.message,
                status: error.status,
            },
        };
    }
};

// delete hall image
export const deleteHallImage = async ({ id }) => {
    try {
        const result = await deleteData(`/hall-images/delete-hall-image/${id}`);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Delete Hall Image API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

// update hall image data
export const updateHallImage = async ({ id, data }) => {
    try {
        const result = await putData(`/hall-images/update-hall-image/${id}`, data, { "Content-Type": "multipart/form-data" });
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Update Hall Image API error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.errors : error.message,
                status: error.status,
            },
        };
    }
};

export const getHallList = async () => {
    try {
        const result = await getData(`/hall-images/hall-list`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Hall List API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
}
